/**
 * The Customer API base URL this build was configured with, or `undefined`
 * when the deployment environment has none.
 *
 * `rsbuild.config.ts` inlines `REACT_APP_CUSTOMER_API_URL` at build time and,
 * when it is unset, substitutes an unresolvable `.invalid` host so a missing
 * variable never points customers at staging. That placeholder counts as
 * unset here.
 *
 * Its own module so tests can mock it: the inlined read cannot be steered by
 * assigning to `process.env`.
 */
export const UNCONFIGURED_CUSTOMER_API_HOST = "customer-api-url-not-configured.invalid";

export function configuredCustomerApiUrl(): string | undefined {
  const url = process.env.REACT_APP_CUSTOMER_API_URL;
  if (!url || url.includes(UNCONFIGURED_CUSTOMER_API_HOST)) return undefined;
  return url;
}
